// extracted by mini-css-extract-plugin
export default {"wrapper":"MaintenancePage_wrapper__t68fn","title":"MaintenancePage_title__JMYJ6","subtitle":"MaintenancePage_subtitle__koRQY"};